export default __webpack_public_path__ + "static/media/bankingicon.b3c3a0e5.svg";